<mat-dialog-content class="d-flex flex-col">

    <div class="flex-row flex-space-between">
        <div>
            <mat-card-header class="p-0">
                <mat-card-title>
                    <h3 class="m-0">New Access Permission for {{ title }}</h3>
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button class="mat-dialog-close " mat-dialog-close mat-icon-button matTooltip="Close Modal"
                    tabindex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="d-flex flex-row mobile-col justify-content-center">
        <form [formGroup]="permissionForm">
            <mat-form-field appearance="outline" class="w-100" color="primary">
                <mat-label>Select User</mat-label>
                <input #userInput [formControl]="userSearchControl"
                       [matAutocomplete]="auto" matInput placeholder="Select User">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)='selectUser($event.option.value)'
                                  [displayWith]="displayFn">
                    @for (user of filteredUsers; track user) {
                        @if (!checkIfUserInArray(user, this.currentPermissions)) {
                            <mat-option [value]="user">
                                {{ nameDisplay(user) }}
                            </mat-option>
                        }
                    }
                </mat-autocomplete>
                @if (loadingUsers) {
                    <mat-icon matSuffix>
                        <mat-spinner color="primary"></mat-spinner>
                    </mat-icon>
                }
                @if (userSearchControl.value?.length < 3) {
                    <mat-hint>A minimum of 3 characters is required to search
                    </mat-hint>
                }
            </mat-form-field>

            <mat-form-field appearance="outline" class=" w-100 pt-10 noPaddingBottom" color="primary">
                <mat-label>Permission</mat-label>
                <mat-select formControlName="permission">
                    @for (permission of permissions; track permission) {
                        <mat-option
                                [value]="permission.value">{{ permission.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            @if (isRaa) {
                <mat-form-field appearance="outline" class=" w-100 pt-10 noPaddingBottom" color="primary">
                    <mat-label>Relationship Name</mat-label>
                    <input formControlName="name" matInput type="text">
                </mat-form-field>
            }
            @if (displayCurrentPermissions && currentPermissions.length > 0) {
                <mat-chip-set>
                    @for (permission of currentPermissions; track permission) {
                        <mat-chip>
                            {{ permission.user.username }}: {{ permission.permission | permissionsDisplay | async }}
                        </mat-chip>
                    }
                </mat-chip-set>
            }
        </form>
    </div>
    @if (cannotCreateAccess) {
        <small class="errorMsg">Cannot create new access for users with the role
            '{{ this.selectedUser?.role }}'.</small>
    }
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button (click)="createPermission()"
            [disabled]="this.permissionForm.invalid || !selectedUser?.id || cannotCreateAccess"
            color="primary"
            mat-raised-button>Create
    </button>
</mat-dialog-actions>
